"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Exception = void 0;
var Exception = /** @class */ (function () {
    function Exception(message, wrapped) {
        this.message = message;
        this.wrapped = wrapped;
    }
    return Exception;
}());
exports.Exception = Exception;
//# sourceMappingURL=exception.js.map